import { render, staticRenderFns } from "./EmptyCover.vue?vue&type=template&id=5b1324ff&scoped=true"
import script from "./EmptyCover.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyCover.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EmptyCover.vue?vue&type=style&index=0&id=5b1324ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1324ff",
  null
  
)

export default component.exports